<template>

    <van-form class="default-form" ref="additionalInformation" @failed="onFailed" :show-error="false">

        <van-field placeholder="请输入合同号" label="合同号" class="van-field-border van-field-required"
                   v-model="additionalInformation.contractNum" input-align="right" error-message-align="right"
                   clearable></van-field>

        <van-field placeholder="请输入合同金额" label="FOB金额(美元)" class="van-field-border van-field-required"
                   label-width="auto"
                   v-model="additionalInformation.fobAmount" type="number" input-align="right"
                   error-message-align="right" clearable
                   :rules="rules.fobAmountRule"></van-field>

        <van-field placeholder="请选择付款方式" label="付款方式" class="van-field-border van-field-required"
                   v-model="additionalInformation.payModelLabel" :readonly="true"
                   :rules="rules.payModelRule" input-align="right" error-message-align="right"
                   @click="payModelVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请选择付款日期" label="付款日期" class="van-field-border"
                   v-model="additionalInformation.payTerm" input-align="right"
                   error-message-align="right" @click="payTermVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <!--付款日期-->
        <van-popup v-model="payTermVisible" position="bottom">
            <date-picker @close="payTermVisible = false" @confirm="payTermConfirm"></date-picker>
        </van-popup>

        <van-field placeholder="请选择贸易方式" label="贸易方式" class="van-field-border van-field-required"
                   v-model="additionalInformation.tradeModelLabel" input-align="right" error-message-align="right"
                   :rules="rules.tradeModelRule" :readonly="true"
                   @click="tradeModelVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <!--手签员-->
        <van-field placeholder="请输入需要签字的手签员" label="手签员" class="van-field-border van-field-required" input-align="right"
                   error-message-align="right"
                   :rules="rules.handSignerRule"
                   v-model="additionalInformation.handSigner" clearable>
            <span slot="label">手签员<i class="extra-cont">Authorised signatory</i> </span>
        </van-field>

        <van-field placeholder="请输入信用证号码" label="信用证号" class="van-field-border" input-align="right"
                   error-message-align="right"
                   v-model="additionalInformation.creditNum" clearable></van-field>

        <van-field placeholder="请输入信用证开证日期" label="信用证开证日期" label-width="auto"
                   v-model="additionalInformation.certificateTime" :readonly="true" class="van-field-border"
                   @click="certificateTimeVisible = true" input-align="right" error-message-align="right">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请输入报关单号" label="报关单号" input-align="right" error-message-align="right"
                   v-model="additionalInformation.declarationNum" clearable class="van-field-border"></van-field>

        <van-field placeholder="请选择出境海关" label="出境海关" :readonly="true"
                   v-model="additionalInformation.customsLabel" input-align="right" error-message-align="right"
                   :rules="rules.customsRule" class="van-field-border van-field-required"
                   @click="customsIdVisible = true">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field placeholder="请输入企业海关编码" label="企业海关编码" input-align="right" error-message-align="right"
                   v-model="additionalInformation.customsNum" maxlength="10" clearable disabled
                   :rules="rules.customsNumRule" class="van-field-border van-field-required"></van-field>

        <van-field v-if="'REGION_CODE_15' != region.value" placeholder="请选择需要打印的副本数量" label="eCO打印副本数" label-width="auto"
                   v-model="additionalInformation.printNumLabel" :readonly="true"
                   :rules="rules.printNumRule" input-align="right" error-message-align="right"
                   @click="printNumVisible = true" class="van-field-border van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field v-if="checkSignItem(region.value)" placeholder="请选择是否打印企业签章和手签员签名" label="印章、签名选项" label-width="auto"
                   v-model="additionalInformation.signItemLabel" :readonly="true" input-align="right"
                   error-message-align="right"
                   :rules="rules.signItemRule" @click="signItemVisible = true" class="van-field-required">
            <i slot="extra" class="van-icon-arrow van-cell__right-icon van-icon"></i>
        </van-field>

        <van-field v-if="'REGION_CODE_15' != region.value" label="申请本地打印" label-width="auto"
                   input-align="right" error-message-align="right">
            <template #input>
                <van-switch v-model="additionalInformation.isCompPrint" size="20px"></van-switch>
            </template>
        </van-field>

        <van-field v-if="checkCompPrint(region.value)" label="第三方发票" label-width="auto"
                   input-align="right" error-message-align="right">
            <template #input>
                <van-switch v-model="additionalInformation.isThirdPartyInvoice" size="20px"></van-switch>
            </template>
        </van-field>

        <van-field v-if="'REGION_CODE_23' === region.value" label="出口货物为展览品" label-width="auto"
                   input-align="right" error-message-align="right">
            <template #input>
                <van-switch v-model="additionalInformation.isExhibition" size="20px"></van-switch>
            </template>
        </van-field>

        <!--付款方式-->
        <van-popup v-model="payModelVisible" position="bottom">
            <common-picker @close="payModelVisible = false" @confirm="payModelConfirm"
                           :columns="payModelOptions"></common-picker>
        </van-popup>

        <!--贸易方式-->
        <van-popup v-model="tradeModelVisible" position="bottom">
            <common-picker @close="tradeModelVisible = false" @confirm="tradeModelConfirm"
                           :columns="tradeModelOptions"></common-picker>
        </van-popup>

        <!--开证日期-->
        <van-popup v-model="certificateTimeVisible" position="bottom">
            <date-picker @close="certificateTimeVisible = false" @confirm="certificateTimeConfirm"></date-picker>
        </van-popup>

        <!--出境海关-->
        <van-popup v-model="customsIdVisible" position="bottom">
            <common-picker @close="customsIdVisible = false" @confirm="customsIdConfirm"
                           :columns="customsIdOptions"></common-picker>
        </van-popup>

        <!--打印副本数-->
        <van-popup v-model="printNumVisible" position="bottom">
            <common-picker @close="printNumVisible = false" @confirm="printNumConfirm"
                           :columns="printNumOptions"></common-picker>
        </van-popup>

        <!--印证、签名选项-->
        <van-popup v-model="signItemVisible" position="bottom">
            <common-picker @close="signItemVisible = false" @confirm="signItemConfirm"
                           :columns="signItemOptions"></common-picker>
        </van-popup>

    </van-form>


</template>

<script>
    import DatePicker from "../../../component/DatePicker";
    import CommonPicker from '../../../component/CommonPicker'
    import AdditionalInformation from '../../../origin-certificate/dto/AdditionalInformation'
    import dictionaryService from "../../../component/dictionary-service";
    import originCertificateRegion from "../../../origin-certificate/service/origin-certificate-region";

    export default {
        name: "PrefAdditionalInformation",
        props: {
          region: Object,
          enterpriseRecordInfo: Object
        },
        components: {
            DatePicker, CommonPicker
        },
        data() {
            return {
                additionalInformation: new AdditionalInformation(this.enterpriseRecordInfo, 'pref'),
                rules: AdditionalInformation.getRules(),

                payModelVisible: false,
                tradeModelVisible: false,
                certificateTimeVisible: false,
                customsIdVisible: false,
                printNumVisible: false,
                signItemVisible: false,
                payTermVisible: false,

                payModelOptions: [],
                tradeModelOptions: [],
                printNumOptions: [],
                customsIdOptions: [],
                signItemOptions: [],
                additionalInformationErrors: null,
            }
        },
        created() {
            this.loadDictionaryOptions();
        },
        methods: {
            async loadDictionaryOptions() {
                const result = await dictionaryService.getDictionaryIncludeItemsByIds([4, 6, 8, 9, 10]);
                if (result.isSuccess()) {
                    this.payModelOptions = result.data.find(item => item.id == 9).items.filter(item => item.enabled);
                    this.tradeModelOptions = result.data.find(item => item.id == 4).items.filter(item => item.enabled);
                    this.printNumOptions = result.data.find(item => item.id == 8).items.filter(item => item.enabled);
                    this.customsIdOptions = result.data.find(item => item.id == 6).items.filter(item => item.enabled);
                    this.signItemOptions = result.data.find(item => item.id == 10).items.filter(item => item.enabled);
                }
            },
            payTermConfirm(date) {
                this.additionalInformation.payTerm = date;
                this.payTermVisible = false;
            },
            payModelConfirm(selectedPayModel) {
                this.additionalInformation.payModel = selectedPayModel.value;
                this.additionalInformation.payModelLabel = selectedPayModel.label;
                this.payModelVisible = false;
            },
            tradeModelConfirm(selectedTradeModel) {
                this.additionalInformation.tradeModel = selectedTradeModel.value;
                this.additionalInformation.tradeModelLabel = selectedTradeModel.label;
                this.tradeModelVisible = false;
            },
            certificateTimeConfirm(selectedCertificateTime) {
                this.additionalInformation.certificateTime = selectedCertificateTime;
                this.certificateTimeVisible = false;
            },
            customsIdConfirm(selectedCustomsId) {
                this.additionalInformation.customsId = selectedCustomsId.value;
                this.additionalInformation.customsLabel = selectedCustomsId.label;
                this.customsIdVisible = false;
            },
            printNumConfirm(selectedPrintNum) {
                this.additionalInformation.printNum = selectedPrintNum.value;
                this.additionalInformation.printNumLabel = selectedPrintNum.label;
                this.printNumVisible = false;
            },
            signItemConfirm(selectedSignItem) {
                this.additionalInformation.signItem = selectedSignItem.value;
                this.additionalInformation.signItemLabel = selectedSignItem.label;
                this.signItemVisible = false;
            },
            checkCompPrint(value) {
              return originCertificateRegion.checkCompPrint(value)
            },
            checkSignItem(value) {
              return originCertificateRegion.checkSignItem(value)
            },
            async validate() {
                return this.$refs["additionalInformation"].validate().then(() => {
                    return new Promise(resolve => resolve(true))
                }).catch(() => {
                        return new Promise(resolve => resolve(false))
                    }
                )
            },
            onFailed(error) {
                this.additionalInformationErrors = error;
            },
            getAdditionalInformation() {
                return this.additionalInformation;
            }
        }
    }
</script>
